import { FC, Fragment, useCallback } from "react"
import {
  IPreferencesMenuItem,
  IPreferencesMenu,
  IStateRequestUpdate,
  PreferencesMenuItemTypeEnum,
  PreferencesMenuTypeEnum
} from "Data/interfaces/Preferences/IPreferences"
import TableItem from "./components/TableItem"
import CheckAndSelectItem from "./components/CheckAndSelectItem"
import { Main, Top } from "./styles"
import CheckAndSelectTableItem from "./components/CheckAndSelectTableItem"
import LanguageSettings from "../LanguageSettings"

interface IActiveItems {
  active: IPreferencesMenu
  onStateUpdate: (values: IStateRequestUpdate) => void
}

const ActiveItems: FC<IActiveItems> = ({ active, onStateUpdate }) => {
  const ItemComponent = useCallback((
    item: IPreferencesMenuItem,
    index: number,
    itemParentId,
  ) => {
    if (item.Type === PreferencesMenuItemTypeEnum.Table) {
      return (
        <TableItem
          activeType={active.Type}
          itemParentId={itemParentId}
          item={item}
          index={index}
          onStateUpdate={onStateUpdate}
        />
      )
    }
    if (item.Type === PreferencesMenuItemTypeEnum.CheckAndSelect) {
      return (
        <CheckAndSelectItem
          activeType={active.Type}
          itemParentId={itemParentId}
          item={item}
          index={index}
          onStateUpdate={onStateUpdate}
        />
      )
    }
    if (
      item.Type === PreferencesMenuItemTypeEnum.CheckAndSelectTable ||
      item.Type === PreferencesMenuItemTypeEnum.SelectTable
    ) {
      return (
        <CheckAndSelectTableItem
          activeType={active.Type}
          itemParentId={itemParentId}
          item={item}
          index={index}
          hasChecked={item.Type === PreferencesMenuItemTypeEnum.CheckAndSelectTable}
          onStateUpdate={onStateUpdate}
        />
      )
    }
    return <></>
  }, [active, onStateUpdate])

  if (active.Type === PreferencesMenuTypeEnum.Language) {
    return <LanguageSettings />
  }

  return (
    <>
      {active.Items.map((itemParent, index) => (
        <Fragment key={itemParent.Id}>
          <Top hasmargintop={index !== 0}>
            <span className="title">
              {itemParent.Title}
            </span>
          </Top>
          <Main>
            {itemParent?.Items?.map((itemChildren, index) => {
              return ItemComponent(itemChildren, index, itemParent.Id)
            })}
          </Main>
        </Fragment>
      ))}
    </>
  )
}

export default ActiveItems
